var React = require('react');

function File (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"n-icons/pages"},React.createElement("path",{"id":"Vector","d":"M7.3366 6.66667H5.96203H7.3366ZM11.4603 12H5.96203H11.4603ZM11.4603 9.33334H5.96203H11.4603ZM3.21289 14.6667V1.33334H10.0857L14.2095 5.33334V14.6667H3.21289Z","stroke":"#555555","strokeMiterlimit":"10","strokeLinecap":"square","strokeLinejoin":"round"})));
}

File.defaultProps = {"width":"17","height":"16","viewBox":"0 0 17 16","fill":"none"};

module.exports = File;

File.default = File;
